<template>
  <!-- 添加招聘 -->
  <div class="body">
    <div class="app">
      <span class="text">添加招聘信息</span>
    </div>
    <div class="bodyy">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="名称:" prop="recruitmentName">
          <el-input
            v-model="ruleForm.recruitmentName"
            @input="limitation"
            placeholder="请输入名称"
            style="width:100%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位:" prop="position">
          <el-input
            v-model="ruleForm.position"
            @input="limitation"
            placeholder="请输入职位"
            style="width:100%;"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话:" prop="recruitmentPhone">
          <el-input
            v-model.number="ruleForm.recruitmentPhone"
            @input="limitation"
            placeholder="请输入电话"
            style="width:100%;"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="简历上传:"
          class="screenshot"
          prop="delivery"
        >
          <el-upload
            style="margin-right: 85%;"
            class="upload-demo"
            ref="upload"
            :action="imageUrl2"
            :on-success="handleSuccess"
          >
            <el-button size="small" type="primary" icon="el-icon-upload" class="btns">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button class="btn btns" type="primary" @click="submitForm('ruleForm')"
          >提交
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import apiBaseUrl from '../../../config/api'

export default {
  data() {
    return {
      imageUrl2: `${apiBaseUrl}/customerinformation/importFile`, //客资截图
      flag: false, //校验标识
      recruitmentName: '',//名称
      position: '',//职位
      recruitmentPhone: '',//电话
      recruitmentUrl: '',//简历
      ruleForm: {
        adminNo: '',
        recruitmentName: '',
        position: '',
        recruitmentPhone: '',
        recruitmentUrl: '',
      },
      rules: {
        recruitmentName: [
          {required: true, message: "请输入名称", trigger: "blur"}
        ],
        position: [
          {required: true, message: "请输入职位", trigger: "blur"}
        ],
        recruitmentPhone: [
          {required: true, message: "请输入电话", trigger: "blur"}
        ],
      }
    };
  },
  created() {
  },
  methods: {
    //提交
    submitForm(formName) {
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        this.ruleForm.adminNo = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          this.ruleForm.adminNo = JSON.parse(teacher).adminNo;
        }
      }
      axios
        .post(`${apiBaseUrl}/recruitmentInformation/add`, this.ruleForm,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.message,
              type:"success"
            })
            this.$refs.ruleForm.resetFields()
            this.$refs.upload.clearFiles()
          }else {
            this.$message({
              message: res.data.message,
              type:"error"
            })
          }
        })
    },
    //客资来源
    getDataSourse() {
      // axios
      //   .get(`${apiBaseUrl}/customerinformation/sourcelist`) // 请替换为你的API URL
      //   .then((response) => {
      //     this.sources = response.data.data.list
      //   })
      //   .catch((error) => {
      //     console.error(error)
      //   })
    },
    //客资来源负责人
    getDataSoursePeople() {
      // axios
      //   .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`) // 请替换为你的API URL
      //   .then((response) => {
      //     this.sourcesPeople = response.data.data.list
      //     // console.log(response)
      //   })
      //   .catch((error) => {
      //     console.error(error)
      //   })
    },
    //老师ip
    getDataTeachers() {
      // axios
      //   .get(`${apiBaseUrl}/schedule/teacherlist`)
      //   .then((response) => {
      //     this.teachers = response.data.data
      //   })
      //   .catch((error) => {
      //     console.error(error)
      //   })
    },
    // 使用正则表达式去除空格和汉字
    limitation() {
      this.ruleForm.recruitmentPhone = this.ruleForm.recruitmentPhone.replace(
        /[\s\u4e00-\u9fa5]/g,
        ''
      )
    },
    // 上传简历
    handleSuccess(response, file, fileList) {
      this.ruleForm.recruitmentUrl = 'http://mzkt.top/img/' + response.data.url
      this.screenshot = URL.createObjectURL(file.raw)
      // 处理上传成功的回调逻辑
    },
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('只能上传PDF格式的文件！');
        return false;
      }
      return true;
    },

    //添加方式
    handleChangeadd() {
    }
  }
};
</script>
<style scoped>
/* .screenshot >>> .el-form-item__label {
  float: unset !important;
} */
.app {
  width: 100%;
  background-color: #fff;
}

.text {
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
}

.app img {
  width: 100%;
}

.body {
  padding: 15px;
  margin-top: -10px;
}

.bodyy {
  margin-top: 10px;
  /* background-color: #fff; */
}

.demo-ruleForm > .el-form-item {
  margin-bottom: 3.86667vw !important;
}

.input-container,
.upload-container {
  margin-bottom: 15px;
}

.num {
  font-size: 16px;
}

label {
  display: inline-block;
  margin-bottom: 5px;
}

.input {
  width: 82vw;
  height: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
}

.button {
  width: 300px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
}

.btn {
  width: 100%;
  height: 50px;
}

.select {
  width: 88vw;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  margin-bottom: 0.66667vw;
}

.required {
  color: red;
}

.button-container {
  /* display: flex;
  justify-content: space-between; */
  text-align: center;
  margin-top: 50px;
}

/* /* .button {
  flex: 1;
  margin-right: 10px;
}  */

.submit {
  background-color: #007bff;
  color: #fff;
}

.success {
  background-color: #ccc;
  color: white;
  /* 其他样式属性 */
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .el-radio-group {
    display: flex;
    padding-top: 7px;
  }

  .screenshot {
    width: 150px;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/AddRecruitment.vue